import type { VisitStatus } from "@school-sales-ai/shared";

export const STATUS_LABEL: Record<VisitStatus, string> = {
  scheduled: "Agendada",
  cancelled: "Cancelada",
  attended: "Asistió",
  no_show: "No asistió",
};

export const STATUS_BADGE: Record<VisitStatus, string> = {
  scheduled: "bg-emerald-50 text-emerald-700",
  cancelled: "bg-ink-050 text-ink-500",
  attended: "bg-blue-50 text-blue-700",
  no_show: "bg-amber-50 text-amber-700",
};

export function formatVisitDateTime(iso: string): string {
  return new Intl.DateTimeFormat("es-MX", {
    weekday: "long",
    day: "numeric",
    month: "long",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(new Date(iso));
}

/** Minutes-since-midnight → "9:00 a.m." for availability/blackout displays. */
export function formatMinuteOfDay(minute: number): string {
  const h24 = Math.floor(minute / 60);
  const m = minute % 60;
  const suffix = h24 < 12 ? "a.m." : "p.m.";
  const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
  return `${h12}:${String(m).padStart(2, "0")} ${suffix}`;
}
